import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';
import { queryClient } from './lib/queryClient';
import { LoadingOverlayProvider } from './lib/loadingOverlay';
import { BackgroundTasksProvider } from './lib/backgroundTasks';
import { ToastProvider } from './lib/toast';
import { ThemeProvider } from './lib/theme';
import './index.css';
import './dark-theme.css';
import './styles/tokens.css';
import './styles/brand.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <LoadingOverlayProvider>
            <BackgroundTasksProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </BackgroundTasksProvider>
          </LoadingOverlayProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>
);
